import { render, staticRenderFns } from "./CGroups.vue?vue&type=template&id=0a221bbe&scoped=true&"
import script from "./CGroups.vue?vue&type=script&lang=js&"
export * from "./CGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a221bbe",
  null
  
)

export default component.exports